/**
 * The Plus workshop discount: 50% off every public workshop, for AdVenture
 * Plus members only.
 *
 * HOW IT WORKS (2026-09-30, replaces the shared MEMBER50 code)
 *   Every Plus member gets a personal code, e.g. PLUS-PATRICK-7KQ2, minted the
 *   first time their dashboard asks for it (server/lib/member-code.ts). The
 *   code is a normal coupon_codes row with member_id set, so the workshop
 *   checkout applies it like any other coupon, with one extra gate: at
 *   validation AND at checkout the server re-reads that member's Plus status
 *   and refuses the code unless the membership is active right now (trial
 *   counts). Cancel, and the code stops working at the end of the paid
 *   period. Nothing to revoke by hand, nothing to expire.
 *
 *   MEMBER50 (the old shared code every account holder could use, and which
 *   leaked into recap emails and a public slide deck) is deactivated by the
 *   same schema step that adds coupon_codes.member_id (server/lib/pro-schema.ts).
 *   Anyone who still types it gets a message pointing at their dashboard.
 *
 * The percentage below is what every surface SAYS. Personal codes are minted
 * with it, so the two can't drift; if it ever changes, existing rows keep
 * their old percentage until they're re-minted.
 */
export const MEMBER_WORKSHOP_PERCENT_OFF = 50;

/** "50% off" */
export const MEMBER_WORKSHOP_DISCOUNT_LABEL = `${MEMBER_WORKSHOP_PERCENT_OFF}% off`;

/** Prefix of every personal code. Codes look like PLUS-JANE-4K7Q. */
export const MEMBER_CODE_PREFIX = "PLUS";

/** The retired shared code. Kept only so its error message can be specific. */
export const LEGACY_SHARED_CODES: ReadonlyArray<string> = ["MEMBER50", "MEMBER60"];
